;(function (global, factory) {
    typeof define === 'function' && define.amd ? define('sbcExtProductsService',['fetch'], factory) :
    typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require("fetch")) :
    console && console.error('Portal Products Service loaded in a wrong way');
}(this/* window */, function () {

    function PortalProductsService(externalApiDomain, externalApiKey, context, lang) {

        Object.defineProperty(this, 'extApiHost', { enumerable: !0, value: externalApiDomain, configurable: !0, writable: !1 });
        Object.defineProperty(this, 'extApiKey', { enumerable: !0, value: externalApiKey, configurable: !0, writable: !1 });
        Object.defineProperty(this, 'context', { enumerable: !0, value: context, configurable: !0, writable: !1 });
        Object.defineProperty(this, 'lang', { enumerable: !0, value: lang, configurable: !0, writable: !1 });

        Object.defineProperty(this, 'getProductsPath', { enumerable: !0, value: '/pricer/sbc/product', configurable: !0, writable: !0 });
        Object.defineProperty(this, 'productDataUrl', { enumerable: !0, value: '/api/sagedotcom/externalproductapi/getextendeddataasync/', configurable: !0, writable: !0 });
    }

    PortalProductsService.prototype.getProducts = function getProducts(personaId) {

        return fetch(this.buildFullUrl(this.extApiHost, this.getProductsPath, { 'persona': personaId }),
            {
                'method': 'GET',
                'redirect': 'follow',
                'headers': this.getExtProductsHeaders()
            })
            .then(function (resp) {
                return resp.json();
            })
            .then((function (json) {
                return this.extendProductData(json);
            }).bind(this))
            .catch(
                function (err) {
                    eventManager.trigger("Sage:ExternalApiError");
                    console && console.error(err);
                });
    }

    PortalProductsService.prototype.getExtProductsHeaders = function () {
        return {
            'X-API-KEY': this.extApiKey,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };
    }

    PortalProductsService.prototype.extendProductData = function extendProductData(productsObj) {
        if (!('products' in productsObj) || !(productsObj.products instanceof Array)) {
            return productsObj;
        }

        var skus = productsObj.products.map(function(p) {
            return p.parentSku ? p.parentSku + "|" + p.productSku : p.productSku;
        });
        
        if (skus.length === 0) {
            Promise.reject("There is no products"); 
            return;
        }

        return fetch(this.buildFullUrl('', this.productDataUrl, { 'sku': skus.join(','), 'context': this.context, 'lang': this.lang }),
            {
                'method': 'GET',
                'cache': 'no-cache',
                'redirect': 'follow',
                'headers': {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            })
            .then(function (resp) { return resp.json(); })
            .then((function (productsObj, prodExtData) {
                if (!(prodExtData instanceof Array)) {
                    return prodExtData;
                }

                for (var i = 0; i < productsObj.products.length; i++) {
                    for (var j = 0; j < prodExtData.length; j++) {
                        if (productsObj.products[i].parentSku === prodExtData[j].parentSku
                            && productsObj.products[i].productSku === prodExtData[j].sku) {

                            productsObj.products[i].icon = prodExtData[j].icon;
                            productsObj.products[i].videoId = prodExtData[j].videoId;
                            productsObj.products[i].videoThumbnail = prodExtData[j].videoThumbnail;
                            productsObj.products[i].popupHtml = prodExtData[j].popupHtml;
                            productsObj.products[i].popupLearnMoreTooltip = prodExtData[j].popupLearnMoreTooltip;
                            productsObj.products[i].marketingIcon1 = prodExtData[j].marketingIcon1;
                            productsObj.products[i].marketingIconDescription1 = prodExtData[j].marketingIconDescription1;
                            productsObj.products[i].marketingIcon2 = prodExtData[j].marketingIcon2;
                            productsObj.products[i].marketingIconDescription2 = prodExtData[j].marketingIconDescription2;
                            productsObj.products[i].marketingIcon3 = prodExtData[j].marketingIcon3;
                            productsObj.products[i].marketingIconDescription3 = prodExtData[j].marketingIconDescription3;
                        }
                    }
                }

                return productsObj;

            }).bind(this, productsObj),
                function (err) {
                    eventManager.trigger("Sage:ExternalApiError");
                    console && console.error(err);
                });
    }

    PortalProductsService.prototype.buildFullUrl = function buildUrl(host, entryPoint, params) {
        var getParams = params != null
                        ? Object.keys(params)
                                .map(function (key) {
                                    return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
                                }).join('&')
                        : '';

        return host + entryPoint + (getParams.length ? ((~entryPoint.indexOf('?') ? '&' : '?') + getParams) : '');
    }

    return PortalProductsService;
}));
